<template>

<div class="energysource__selection">
          <div v-if="$root.detailsShow != 'energysource'">
            <Pencil />
            Dina tillval är 
            <span class="energysource__text" v-if="$root.energysource==='fossilfriel'"><strong>Fossilfri el</strong>.</span>
            <!--
            <span class="energysource__text" v-if="$root.energysource==='vattenkraft'"><strong>Vattenkraft</strong>.</span>
            <span class="energysource__text" v-if="$root.energysource==='vindkraft'"><strong>Vindkraft</strong>.</span>
            -->
            <span class="energysource__text" v-if="$root.energysource==='karnkraft'"><strong>Kärnkraft</strong>.</span>
            <span class="energysource__text" v-if="$root.energysource==='bramiljoval'"><strong>Bra miljöval ({{$root.timspot_contract().monthName}})</strong>.</span>

            <div style="float:right;display:inline-block;float: right;cursor: pointer;color: #57a3af;line-height: 1.33333rem;list-style-type: none;"><span class="energysource__textlink">Ändra</span> <!--<ChevronDown />--></div>
            <!--<div style="float:right;display:inline-block;" class="contractselection__summary-details-title" v-on:click="showDetails('fixed1')" v-bind:class="{ open: $root.detailsShow==='fixed1' }">Detaljerat pris <ChevronDown /></div>-->
         </div>
         <div id="energysource-selection" class="modal" v-if="$root.detailsShow==='energysource'">
             <div class="content uppgifter">

                <form @submit.prevent="submit" id="energysource-selection-select">
                <div class="uppgifter__block">
                    <h2 class="uppgifter__block-title">Välj tillval</h2>
                    <p class="uppgifter__block-subtitle">Som elhandelsföretag ligger det oss varmt om hjärtat att värna om miljön. All el som vi köper in är fossilfri och produktionen sker främst i vatten-, vind- och kärnkraftverk, men en liten del av elen kommer även från lokalproducerad solenergi. Som kund hos oss kan du själv välja vilken energikälla du vill främja. Om du inte gör något aktivt val får du en mix av fossilfria energikällor.</p>
                    
                    <label class="uppgifter__field-wrapper">
                    <input type="radio" id="energysource" name="energysource" v-model="$root.energysource" class="uppgifter__field" value="fossilfriel">
                    <span class="uppgifter__field-content">
                        <span class="uppgifter__field-label uppgifter__field-label--with-info">
                        <span class="uppgifter__field-label-text">Fossilfri el</span>
                        <span class="info-circle" v-tooltip.top="'Fossilfri el är en mix av vatten-, vind- och kärnkraftsproducerad el.'"><InfoCircle /></span>
                        <span class="uppgifter__field-label-info">0 kr/mån</span>
                        </span>
                    </span>
                    </label>		
                    
                    <label class="uppgifter__field-wrapper" v-if="$root.price_type !='mix5050'">
                    <input type="radio" id="energysource" name="energysource" v-model="$root.energysource" class="uppgifter__field" value="karnkraft">
                    <span class="uppgifter__field-content">
                        <span class="uppgifter__field-label uppgifter__field-label--with-info">
                        <span class="uppgifter__field-label-text">Kärnkraft</span>
                        <span class="info-circle" v-tooltip.top="'Ursprungsmärkt kärnkraft innebär att du får fossilfri el producerad från svenska kärnkraftverk.'"><InfoCircle /></span>
                        <span class="uppgifter__field-label-info">0 kr/mån</span>
                        </span>
                    </span>
                    </label>
            
                    <label class="uppgifter__field-wrapper">
                    <input type="radio" id="energysource" name="energysource" v-model="$root.energysource" class="uppgifter__field" value="bramiljoval">
                    <span class="uppgifter__field-content">
                        <span class="uppgifter__field-label uppgifter__field-label--with-info">
                        <span class="uppgifter__field-label-text">Bra miljöval ({{$root.timspot_contract().monthName}})</span>
                        <span class="info-circle" v-tooltip.top="'Bra Miljöval är ett rörligt pris som ändras varje månad. Bra Miljöval är 100 % förnybar el, men bara från anläggningar som Bra Miljöval godkänt. Miljökraven på den förnybara elproduktionen innebär hänsyn till miljö, klimat, växter, djur och människor. Man stöttar projekt som reparerar miljöskador i naturen och minskar energianvändningen. All såld miljömärkt el bidrar med pengar till Bra Miljöval Fonder. En certifiering av förnybar el är Bra Miljöval.'"><InfoCircle /></span>
                        <span class="uppgifter__field-label-info">{{$root.getEnergySourcePriceText('bramiljoval', true)}}</span>
                        </span>
                    </span>
                    </label>
                </div>
                <div class="step-nav">
                    <button type="submit" class="button button--with-icon step-nav__button">Fortsätt <Arrow /></button>
                </div>                
                </form>	
	

             </div>
         </div>

      </div>

</template>

<script>
  export default {
    methods: {
      submit() {
        this.$root.showDetails('energysource');
      }
    },
  }
  </script>